import _curry3 from "./internal/_curry3.js";
import adjust from "./adjust.js";
import always from "./always.js";
var update = _curry3(function update(idx, x, list) {
    return adjust(idx, always(x), list);
});
export default update;
